import { get } from '../index';

export const getUsers = (company) => {
  return get(`/invites/users/${company}`);
};

export const getUsersByUserId = (userId) => {
  return get(`/users/${userId}`);
};
